/**
 * Which fragment a run surface is currently showing.
 *
 * One implementation, because as of flowstack#991 TWO surfaces have to agree
 * on the answer: the torsion plots in the workspace's main area, and the side
 * panel that names the fragment those curves belong to. Two components each
 * resolving "current fragment" their own way is how a panel ends up captioned
 * `frag-1` beside `frag-0`'s curves.
 *
 * Reconciled against the CURRENT list rather than merely remembered: the list
 * GROWS while a run is live, and a resume can supersede a fragment's result
 * entirely, so a remembered id can name a fragment that is no longer there.
 * Same reasoning as `AnalysisTab`'s `selectionIsCurrent`.
 */
export function resolveFragmentId(
  fragments: readonly { fragment_id: string }[],
  picked: string | null
): string | null {
  if (picked !== null && fragments.some((f) => f.fragment_id === picked)) return picked;
  return fragments[0]?.fragment_id ?? null;
}
